<template>
  <div style="background: #FFFFFF;padding-top: 15px;">
    <!--个人信息和几个模块快速练链接-->
    <div class="new_user_top2">
      <div class="nut2_left">
        <div class="nut2l_tx"><img :src="userInfo.imageUrl"/></div>
        <div class="nut2l_info">
          <p>{{ userInfo.realName }}</p>
          <p :title="userInfo.company.companyName">{{ userInfo.company.companyName }}</p>
          <p>
            <router-link :to="{ path: '/EditUser', query: { baseVisible: true }}">账号设置</router-link>
            <a href="javascript:" @click="myCorrection">我的纠错</a></p>
          <el-dialog :visible.sync="myCorrectionVisible" title="我的纠错" width="90%">
            <el-table :data="myCorrectionData">
              <el-table-column label="题干">
                <template slot-scope="scope"><span v-html="scope.row.content"></span></template>
              </el-table-column>
              <el-table-column label="纠错时间" property="ctime" width="200"></el-table-column>
              <el-table-column label="处理反馈" property="correctMsg"></el-table-column>
            </el-table>
          </el-dialog>
        </div>
      </div>
      <div class="nut2_right">
        <div class="nut2r">
          <!--<router-link class="nut2r_wdlx" to="/MyPractise" style="color: #fff;">我的练习</router-link>
          <router-link class="nut2r_wdks" to="/MyExam" style="color: #fff;">我的考试</router-link>-->
          <el-tooltip content=" 此功能暂未开通 ">
            <a class="nut2r_wdlx" href="javascript:" style="color: #FFFFFF;" @click="notice"> 我的练习 </a>
          </el-tooltip>
          <el-tooltip content=" 此功能暂未开通 ">
            <a class="nut2r_wdks" href="javascript:" style="color: #FFFFFF;" @click="notice"> 我的考试 </a>
          </el-tooltip>
          <router-link class="nut2r_wdxf" style="color: #FFFFFF;" to="/MyScore">我的学分</router-link>
          <router-link class="nut2r_pxjl" style="color: #FFFFFF;" to="/MyTraining">培训记录</router-link>
          <router-link class="nut2r_bkjl" style="color: #FFFFFF;" to="/MyCard">绑卡记录</router-link>
        </div>
      </div>
    </div>
    
    <div v-if="trainingList&&trainingList.length==0" class="new_user_project_noSource">暂无推荐项目，请确认个人信息的准确性，以便及时获取推荐项目；<br/>若有疑问请拨打客服电话：<span>400-822-2055</span>
    </div>
    
    <div v-else class="new_user_project">
      <div class="nup_top">
        <div class="nupt_title">我的课程</div>
        <div class="nupt_main">
          <a v-for="(item, index) in trainingList" :key="index" :class="{ nupt_main_sel: currentTraining.id===item.id }"
            :title="item.name"
            href="javascript:" @click="switchTraining(item)">{{ item.name }}</a>
        </div>
      </div>
      <!--继教-->
      <cme-page v-if="currentTraining && currentTraining.businessType==102"
        :currentTraining="currentTraining"></cme-page>
      <!--非继教-->
      <not-cme-page v-if="currentTraining && currentTraining.businessType!=102"
        :currentTraining="currentTraining"></not-cme-page>
    </div>
    
    
    <learnCardBind :value.sync="showLearnCardBind"></learnCardBind>
    
    <el-dialog :close-on-click-modal="false" :close-on-press-escape="false" :show-close="false"
      :visible.sync="examVisible" style="text-align: center">
      <p style="font-size: 16px;font-weight: bold">您有一场需在开始课程学习前进行的考试，请确认是否开始考试？</p>
      
      <el-button style="margin-top: 40px;" type="primary" @click="openExamPage">开始考试</el-button>
      <el-button @click.native="examVisible = false">忽略考试</el-button>
    </el-dialog>
    <verifiModal :usermobile="userInfo.mobile" :verifiModalVisible.sync="verifiModalVisible"></verifiModal>
    <!--修改密码-->
    <ChangePassword v-model="changePasswordShow"></ChangePassword>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import {
  existAssignOrg,
  getBeginExamUrl,
  getStudentDetail,
  haveBandedLearningCard,
  listStudentTraining,
  showExamVisible,
  validateUserCreditBindingTerm
} from '../../api/api'
import jsonp from 'jsonp'
import axios from 'axios'
import cmePage from '../../components/CmePage'
import notCmePage from '../../components/NotCmePage'
import learnCardBind from '../../components/LearnCardBind'
import header3 from '../../components/Header3'
import ChangePassword from '../../components/ChangePassword/index.vue'
import VerifiModal from '../../components/VerifiModal.vue'

export default {
  components: {
    VerifiModal,
    cmePage,
    notCmePage,
    learnCardBind,
    header3,
    ChangePassword
  },
  data() {
    return {
      examRealUrl: '',
      examVisible: false,
      trainingList: null,
      currentTraining: null,
      showLearnCardBind: false,
      myCorrectionVisible: false,
      myCorrectionData: [],
      yjwsVisible: false,
      changePasswordShow: false,
      verifiModalVisible: false
    }
  },
  computed: {
    ...mapGetters([
      'userInfo'
    ])
  },
  mounted() {
    document.getElementById('J_GotoTop').style.visibility = 'visible'//隐藏在线客服
    this.weakPasswordDetection()
  },
  created() {
    existAssignOrg({
      userId: this.userInfo.id,
      provinceId: 1053
    }).then((response) => {
      this.yjwsVisible = response.data.data.exist
    })
    
    listStudentTraining({//获得学员所有培训班
      userId: this.userInfo.id,
      excludeExpire: true,
      trainingWay: '1'
    }).then((response) => {
      var trainingId = this.$route.query.trainingId
      const list = response.data.data.list || []
      const notShowId = [1880, 2170, 2445, 2557] //不显示的培训班id
      this.trainingList = list.map(v => {
        if (!notShowId.includes(v.id)) return v
      }).filter(v => v)
      
      if (this.trainingList.length > 0) {
        var currentId = '0'
        for (var i = 0; i < this.trainingList.length; i++) {
          if (this.trainingList[i].id == trainingId) {
            currentId = i
            break
          }
        }
        this.switchTraining(this.trainingList[currentId])
        this.showExamVisibleFunction(this.userInfo.id, this.currentTraining.id)
      }
    })
    
  },
  methods: {
    /**
     * @description: 首页初始化进行弱密码检测
     */
    weakPasswordDetection() {
      const token = localStorage.getItem(`${ process.env.APPKEY }token`)
      if (!this.userInfo || !token) return
      const pwWeak = localStorage.getItem(`${ this.userInfo.uuid }_pw_weak`)
      // 已经登录并且有弱密码标记的进如修改密码步骤
      if (pwWeak) {
        this.changePasswordShow = true
      } else {
        if (!this.userInfo.mobile || this.userInfo.isMobileVerify !== 1) {
          this.verifiModalVisible = true
        }
      }
    },
    showExamVisibleFunction(userId, trainingId) {
      showExamVisible({//验证学员是否有学习前需要的考试
        userId: userId,
        trainingId: trainingId
      }).then((response) => {
        if (response.data.status > 0) {
          this.examVisible = true
          if (response.data.examType == 1) {
            this.examRealUrl = process.env.ZHUNBEI_EXAM_URL
            if (response.data.examTypeDetail == 3) {
              this.examRealUrl = process.env.YSDK_EXAM_URL
            } else if (response.data.examTypeDetail == 105) {
              this.examRealUrl = process.env.ZHUNBEI_MONI_EXAM_URL
            }
          } else {
            getBeginExamUrl({userId: userId, examId: response.data.examId}).then((response) => {
              this.examRealUrl = response.data
            })
          }
        }
      })
    },
    
    /*createExamUrl(examId){
     let ts = new Date().getTime().toString();
     let fp = md5(this.userInfo.id + ts + "usercenter").toString().toUpperCase();
     
     let reUrl = process.env.PRACTISE_URL + "api/user/login/oauth2"
     + "?" + "turl=" + encodeURIComponent(process.env.PRACTISE_URL + "online/byks/examNotice.html") //开始考试的地址
     + "&" + "eurl=" + encodeURIComponent(process.env.WEB30_URL + "usercenter") // 考试结束回调地址
     + "&" + "ts=" + ts
     + "&" + "from=" + "usercenter"
     + "&" + "fp=" + fp
     + "&" + "userId=" + this.userInfo.id
     + "&" + "examId=" + examId;
     
     return reUrl;
     },*/
    
    notice() {
      this.$message({
        type: 'success',
        message: '此功能暂未开通'
      })
    },
    openExamPage() {
      let newWindow = window.open('', 'practiceOnly')
      validateUserCreditBindingTerm({
        trainingIds: this.currentTraining.id,
        userId: this.userInfo.id
      }).then((response) => {
        
        if (response.data == false) {
          newWindow.close()
          this.showLearnCardBind = true
        } else {
          newWindow.location = this.examRealUrl
          this.examVisible = false
        }
      })
      
    },
    
    switchTraining(trainingInfo) {
      this.currentTraining = trainingInfo
      this.haveBandedLearningCard()
      this.showExamVisibleFunction(this.userInfo.id, this.currentTraining.id)
    },
    haveBandedLearningCard() {
      haveBandedLearningCard({
        trainingId: this.currentTraining.id,
        userId: this.userInfo.id
      }).then((response) => {
        if (response.data == true) {
          this.currentTraining.isBandLearningCard = true
        } else {
          this.currentTraining.isBandLearningCard = false
        }
        
      })
    },
    myCorrection() {
      jsonp(process.env.EXAM_API_URL + 'questionErrorCorrect/getUserCorrectionRecord?studentId=' + this.userInfo.id
        , (err, data) => {
          if (err) {
            this.$message.error('加载异常')
            return null
          } else {
            if (data.status == 0) {
              this.myCorrectionData = data.data
              this.myCorrectionVisible = true
            } else {
              this.$message.error(data.message)
            }
          }
        })
    },
    loginOldWeb() {
      getStudentDetail({id: this.userInfo.id}).then((res) => {
        var userInfo = res.data.data.data
        axios({
          method: 'get',
          url: process.env.OLD_INDEX_URL + 'account/ajaxLogin?userName=' + userInfo.userName + '&password=' + userInfo.passWord + '&auto=false',
          withCredentials: true
        }).then((response) => {
          if (response.data.status != 'succeed') {
          }
          window.location = process.env.OLD_INDEX_URL + '/account/ynwsyjjnSystemLogin'
        })
      })
    }
  }
}
</script>

<style scoped>
.art_desc {
  font-size: 14px;
  width: 1000px;
  margin: 0 auto;
  padding: 10px;
  color: #333333;
  border-left: 3px solid #3BB0DB;
  background: #4DD86B;
}

.beginExam {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 630px;
  height: 200px;
  margin-top: -100px;
  margin-left: -315px;
  background: #FFFFFF
}

.bE_main {
  position: absolute;
  top: 40px;
  left: 0;
  display: block;
  display: inline-block;
  width: 100%;
  height: 100%;
}

.bE_main p {
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 30px;
  text-align: center;
  color: #333333;
}

.bEm_button {
  width: 250px;
  margin: 0 auto;
  margin-top: 20px;
}

.bEm_button button:nth-child(1) {
  float: left;
  cursor: pointer;
  color: #FFFFFF;
  border: 1px solid #0BA9C3;
  background: #3BC4DA;
}

.bEm_button button:nth-child(2) {
  float: right;
  cursor: pointer;
  color: #FFFFFF;
  border: 1px solid #ACACAC;
  background: #BCBCBC;
}
</style>



// WEBPACK FOOTER //
// src/views/usercenter/Index.vue